import React from "react";
//import { withRouter } from 'react-router';
import { Button, Icon, Col, Row } from "react-materialize";
import Moment from "react-moment";

import BaseView from "../base-view/BaseView";
import CommonContants from "../../constants/CommonConstants";
import StatusInfomartion from "../../components/status-information/StatusInformation";
import ReportOptionsModal from "../../components/report-options-modal/ReportOptionsModal";
import EventUtils from "../../utils/EventUtils";
import ObjectUtils from "../../utils/ObjectUtils";

import defaultImage from "../../images/EmptyPicture.png";
import "./ReportView.css";

class ReportView extends BaseView {
  static VIEW_PATH = "/report";

  constructor(props) {
    super(props);

    this.state = {
      imageSize: CommonContants.FILE_VIEWS_ORIGINAL,
      properties: [],
    };

    this.cartItems = [];
    this.selectedAssetTypes = [];
    this.selectedAssetType = "";

    this._handlePrintClick = this._handlePrintClick.bind(this);
    this._handleReportOptionsChanged = this._handleReportOptionsChanged.bind(
      this
    );
    this._handleChangeConfigurationClick = this._handleChangeConfigurationClick.bind(
      this
    );
    this._handleBackClick = this._handleBackClick.bind(this);
    this._getPropertyValue = this._getPropertyValue.bind(this);
  }

  _handlePrintClick(event) {
    window.print();
  }

  _handleReportOptionsChanged(event) {
    const { imageSize, properties } = event.detail;
    this.setState({ imageSize: imageSize, properties: properties });
  }

  _handleChangeConfigurationClick(event) {
    const { items } = this.props;

    if (items && items.length > 0) {
      window.$("#report-form-modal").modal("open");
    }
  }

  _handleBackClick(event) {
    EventUtils.raiseEvent("back-click", {}, this.props);
  }

  _getAssetType(itemsType) {
    let assetType = "";

    if (itemsType.length === 1) {
      assetType =
        itemsType[0] === CommonContants.ARCHIVE_ASSETS_FILE_TYPE
          ? CommonContants.ARCHIVE_ASSETS_FILE_TYPE
          : CommonContants.ACTIVE_ASSETS_FILE_TYPE;
    } else {
      assetType = CommonContants.MIXED_ASSETS_FILE_TYPE;
    }

    return assetType;
  }

  _getPropertyValue(key, item) {
    if (key === undefined) {
      return null;
    }
    try {
      if (key.indexOf(".") !== -1) {
        let keyArray = key.split(".");
        return item.properties[keyArray[0]][keyArray[1]];
      } else {
        return item.properties[key];
      }
    } catch {
      return "NA";
    }
  }

  componentWillMount() {
    const { items } = this.props;

    //Sorting  the cart items
    /*this.cartItems = items.sort(function(a, b) {
      return (a.type < b.type) ? -1 : (a.type > b.type) ? 1 : 0;
    });*/

    //Find the asset type
    this.selectedAssetTypes = [...new Set(items.map((item) => item.type))];
    this.selectedAssetType = this._getAssetType(this.selectedAssetTypes);
  }

  componentDidMount() {
    const { items } = this.props;

    if (items && items.length > 0) {
      window.$("#report-form-modal").modal("open");
    }
  }

  render() {
    const hrefLink = "#";
    const { items } = this.props;
    let { imageSize, properties } = this.state;

    if (!items || items.length === 0) {
      return (
        <StatusInfomartion
          title="Failed to create report"
          subtitle="Can't create a new report without selecting items in the cart."
          onBackClick={this._handleBackClick}
        />
      );
    }

    if (typeof properties === "object" && properties !== null) {
      properties = ObjectUtils.objectSortingByValue(properties);
    }

    let propertiesGroups = [];
    let count = 0;
    let group = 0;
    for (let property in properties) {
      if (count === 0) {
        propertiesGroups[group] = {};
      }

      propertiesGroups[group][property] = properties[property];
      count++;

      if (count === 5) {
        count = 0;
        group++;
      }
    }

    return (
      <section className="report-view">
        <div className="main">
          <header className="main-header">
            <a
              href={hrefLink}
              className="btn-link"
              onClick={this._handleBackClick}>
              <Icon tiny>arrow_back</Icon> Back
            </a>
            <Button
              floating
              className="report-btn"
              waves="teal"
              tooltip="Change Report Configuration"
              onClick={this._handleChangeConfigurationClick}>
              <Icon tiny>settings</Icon>
            </Button>
            <Button
              floating
              className="report-btn"
              waves="teal"
              tooltip="Print"
              onClick={this._handlePrintClick}>
              <Icon tiny>print</Icon>
            </Button>
          </header>
          <div className="report">
            <div className="report-header">
              <h2 className="title">Brand Assurance Submission Report</h2>
              <h2 className="date">
                <Moment format={CommonContants.NUXEO_DATE_FORMAT}>
                  {new Date()}
                </Moment>
              </h2>
            </div>

            <div className="report-body">
              {items.map((item, id) => {
                let views = item.properties["picture:views"];
                let type = item.type;
                let property_view =
                  type === CommonContants.ARCHIVE_ASSETS_FILE_TYPE
                    ? CommonContants.ARCHIVE_PROPERTIES_TO_SHOW
                    : CommonContants.ACTIVE_PROPERTIES_TO_SHOW;

                let asset_title = "";
                try {
                  asset_title =
                    type === CommonContants.ARCHIVE_ASSETS_FILE_TYPE
                      ? item.properties["archive_file:archiveSubmission"][
                          "title"
                        ]
                      : item.properties["live_file:liveSubmissionTitle"];
                } catch {
                  asset_title = "NA";
                }
                return (
                  <div className="report-item" key={id}>
                    <h3 className="report-item-title">{asset_title}</h3>
                    {propertiesGroups.map((propertiesGroup, id) => {
                      return (
                        <Row key={id}>
                          <Col s={12}>
                            <table>
                              <thead>
                                <tr>
                                  {Object.keys(propertiesGroup).map(
                                    (property, id) => (
                                      <th key={id}>
                                        {propertiesGroup[property]}
                                      </th>
                                    )
                                  )}
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  {Object.keys(propertiesGroup).map(
                                    (property, id) => {
                                      let propertyKey = Object.keys(
                                        property_view
                                      ).find(
                                        (key) =>
                                          property_view[key] ===
                                          propertiesGroup[property]
                                      );

                                      let propertyValue = this._getPropertyValue(
                                        propertyKey,
                                        item
                                      );
                                      return property.includes("Date") ? (
                                        <td key={id}>
                                          {propertyValue === null ? (
                                            ""
                                          ) : (
                                            <Moment
                                              format={
                                                CommonContants.NUXEO_DATE_FORMAT
                                              }>
                                              {propertyValue}
                                            </Moment>
                                          )}
                                        </td>
                                      ) : (
                                        <td key={id}>{propertyValue}</td>
                                      );
                                    }
                                  )}
                                </tr>
                              </tbody>
                            </table>
                          </Col>
                        </Row>
                      );
                    })}
                    <div className="image-container">
                      <img
                        src={
                          views.length > 0
                            ? views[imageSize].content.data
                            : defaultImage
                        }
                        alt={item.title}
                        className={
                          views.length > 0
                            ? `img-${views[imageSize].title}`
                            : "img-default"
                        }
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <ReportOptionsModal
          onChanged={this._handleReportOptionsChanged}
          selectedAssetType={this.selectedAssetType}
        />
      </section>
    );
  }
}

export default ReportView;
